import React from "react";
import { Autoplay, FreeMode, Pagination } from "swiper/modules";
import { SwiperSlide, Swiper } from "swiper/react";
import useScrollAnimation from "@/hooks/useScrollAnimation";

export const testimonials = [
    {
        id: "maya",
        name: "نورة الشمري",
        role: "مديرة التسويق - بنك رقمي",
        rating: 5,
        date: "نوفمبر 2025",
        quote: "الفريق لم يقدم تصميمًا فقط، بل فهم خلفية العلامة بالكامل، وقدم حملة متكاملة منحتنا حضورًا قويًا منذ الأسبوع الأول للإطلاق.",
        accent: "bg-gradient-to-br from-primary-500/90 to-sky-400/70",
    },
    {
        id: "tariq",
        name: "خالد العتيبي",
        role: "مؤسس منصة تعليمية",
        rating: 5,
        date: "أغسطس 2025",
        quote: "واجهتنا مشكلة في تجربة المستخدم، وتم تحويل الرحلة الرقمية لطلابنا إلى تجربة سلسة وممتعة، ما ضاعف الاشتراكات المدفوعة.",
        accent: "bg-gradient-to-br from-amber-500/80 to-orange-400/60",
    },
    {
        id: "hend",
        name: "سارة القحطاني",
        role: "قائدة النمو - شركة تقنية مالية",
        rating: 4,
        date: "يوليو 2025",
        quote: "التحليل العميق والتطبيق العملي للأتمتة وفر علينا وقت الفريق، وأتاح لنا رؤية آنية للأداء مع قرارات أسرع وأدق.",
        accent: "bg-gradient-to-br from-emerald-500/80 to-teal-400/60",
    },
    {
        id: "mostafa",
        name: "عبدالله الدوسري",
        role: "مدير المبيعات - شركة عقارية",
        rating: 5,
        date: "سبتمبر 2025",
        quote: "التطبيق الذي طوروه لنا سهّل عملية البحث والحجز على عملائنا بشكل كبير، والنتائج تجاوزت توقعاتنا من حيث زيادة المبيعات.",
        accent: "bg-gradient-to-br from-violet-500/80 to-purple-400/60",
    },
    {
        id: "ahmed",
        name: "فاطمة الحربي",
        role: "مديرة العلامة التجارية - متجر إلكتروني",
        rating: 5,
        date: "أكتوبر 2025",
        quote: "الحملات الإعلانية والتصاميم الإبداعية رفعت مستوى تفاعل العملاء بنسبة ملحوظة، والفريق كان متعاوناً ومحترفاً في كل مرحلة.",
        accent: "bg-gradient-to-br from-rose-500/80 to-pink-400/60",
    },
];

const Testimonials = () => {
    const headerAnimation = useScrollAnimation();
    const swiperAnimation = useScrollAnimation({ threshold: 0.2 });

    return (
        <section className="py-20">
            <div className="max-w-7xl mx-auto px-4">
                <div
                    ref={headerAnimation.ref}
                    className={`text-center max-w-2xl mx-auto scroll-fade-in-up ${headerAnimation.isVisible ? "visible" : ""}`}
                >
                    <h2 className="mt-6 text-2xl lg:text-4xl font-bold text-slate-900 leading-tight">
                        قصص نجاح يرويها عملاؤنا
                    </h2>
                    <p className="mt-4 text-base lg:text-lg text-slate-600">
                        اخترنا هذه الشهادات من شركاء عاشوا التحول في منتجاتهم
                        وحملاتهم، بعد تعاون مشترك ركّز على الأثر الملموس.
                    </p>
                </div>

                <div
                    ref={swiperAnimation.ref}
                    className={`relative mt-16 scroll-scale-in ${swiperAnimation.isVisible ? "visible" : ""}`}
                >
                    <Swiper
                        modules={[Autoplay, Pagination, FreeMode]}
                        freeMode
                        autoplay={{
                            delay: 4500,
                            disableOnInteraction: false,
                        }}
                        spaceBetween={12}
                        slidesPerView={1.05}
                        breakpoints={{
                            640: { slidesPerView: 1.2 },
                            768: { slidesPerView: 1.6 },
                            1024: { slidesPerView: 2.2 },
                            1280: { slidesPerView: 2.5 },
                        }}
                        className="testimonials-swiper pb-12"
                    >
                        {testimonials.map((testimonial, index) => (
                            <SwiperSlide
                                key={testimonial.id}
                                className="!h-[280px] p-2"
                            >
                                <article className="flex h-full flex-col rounded-3xl border border-white/60 bg-white/85 p-8 shadow-[0_1px_10px_0_rgba(0,0,0,0.15)] backdrop-blur-sm">
                                    <p className="text-xs text-slate-400">
                                        {testimonial.date}
                                    </p>

                                    <p className="mt-2 text-sm lg:mt-6 lg:text-base font-medium leading-7 text-slate-700">
                                        "{testimonial.quote}"
                                    </p>

                                    <div className="mt-auto flex items-center gap-4">
                                        <div className="min-w-0">
                                            <p className="text-sm font-semibold text-slate-900">
                                                {testimonial.name}
                                            </p>
                                            <p className="text-xs text-slate-500">
                                                {testimonial.role}
                                            </p>
                                        </div>
                                        <div
                                            className={`flex h-12 w-12 items-center justify-center rounded-full text-sm font-semibold text-white ms-auto ${testimonial.accent}`}
                                        >
                                            {testimonial.name.slice(0, 2)}
                                        </div>
                                    </div>
                                </article>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
            </div>
        </section>
    );
};

export default Testimonials;
